import {
  CheckboxInput,
  FormItem,
  SelectInput,
  useField,
} from '@framework/form';
import { yup } from '@framework/validation';
import { Collapse } from 'antd';
import React from 'react';
import { StyledDrawerCollapse } from '../../../../../ui/drawer/StyledDrawerCollapse';
import { IWidgetComponentProps } from '../../../IWidgetType';
import { WidgetType } from '../../../Widget';
import { BaseLayoutSchema } from '../../common/BaseLayoutSchema';
import {
  CommonConfigComponent,
  CommonInputWidgetConfigSchema,
} from '../common/CommonInputConfigComponent';
import {
  CommonOptionListConfigComponent,
  commonOptionListDirectionValidator,
  commonOptionListSeparatorValidator,
} from '../common/option-list/CommonOptionListConfigComponent';
import { SetOptionsFromVariableInput } from '../common/option-list/SetOptionsFromVariableInput';
import { WidgetOptionItemList } from '../common/option-list/WidgetOptionItemList';
import { widgetOptionArrayValidator } from '../common/option-list/validation/optionArrayValidator';
import { ISingleSelectWidget, SingleSelectKind } from './ISingleSelectWidget';
const { Panel } = Collapse;

export const singleSelectInputConfigValidator: yup.ObjectSchema<ISingleSelectWidget> =
  CommonInputWidgetConfigSchema.shape({
    type: yup.string().exact(WidgetType.Select).required(),
    options: widgetOptionArrayValidator,
    kind: yup
      .string()
      .oneOfEnum(SingleSelectKind)
      .default(SingleSelectKind.Radio)
      .required()
      .label('Tipo'),
    layout: BaseLayoutSchema.shape({
      hideLabel: yup.boolean().required().default(false),
    })
      // Opzioni solo per checkbox
      .when('kind', ([kind]: SingleSelectKind[], schema) => {
        if (kind === SingleSelectKind.Radio) {
          return schema.shape({
            direction: commonOptionListDirectionValidator,
            separator: commonOptionListSeparatorValidator,
          });
        }
        return schema;
      })
      .required()
      .noUnknown(),
  })
    .required()
    .noUnknown();

export interface ISingleSelectConfigComponentProps
  extends IWidgetComponentProps<ISingleSelectWidget> {}

export function SingleSelectConfigComponent(
  props: ISingleSelectConfigComponentProps,
) {
  const kindField = useField<SingleSelectKind>('kind');
  const kind = kindField.getValue();

  return (
    <StyledDrawerCollapse defaultActiveKey={['general', 'options']} ghost>
      <Panel header="Impostazioni Generali" key="general">
        <FormItem name="kind" label="Tipo">
          <SelectInput
            name="kind"
            defaultValue={SingleSelectKind.Radio}
            options={[
              {
                label: 'Menù a tendina',
                value: SingleSelectKind.Select,
              },
              {
                label: 'Lista di radio',
                value: SingleSelectKind.Radio,
              },
            ]}
          />
        </FormItem>
        {/* Configurazioni comuni */}
        <CommonConfigComponent
          {...props}
          hideConfigPlaceholder={kind === SingleSelectKind.Radio}
        />

        <FormItem name="layout.hideLabel" layout={{ removeLabelSpace: true }}>
          <CheckboxInput name="layout.hideLabel" defaultChecked={false}>
            Nascondi etichetta
          </CheckboxInput>
        </FormItem>
        {/* Configurazioni multi-select checkbox */}
        {kind === SingleSelectKind.Radio && <CommonOptionListConfigComponent />}
      </Panel>
      <Panel header="Opzioni" key="options">
        <WidgetOptionItemList name={'options'} />
        <SetOptionsFromVariableInput name="options" />
      </Panel>
    </StyledDrawerCollapse>
  );
}
